import {actionMap} from '../reducers/index'
import * as types from './types'
import resetError from "../../../../shared/errorHandler/actions/resetError"

export default (params) => dispatch => {
    dispatch(resetError())
    dispatch({
        type: types.SELECT_DOCUMENT,
        params: params
    })
}

export const handler_SELECT_DOCUMENT = (reduxState, action) => {
    let newSelection = reduxState.selectedIds !== undefined ? reduxState.selectedIds : []

    if (action.params.checked) {
        newSelection.push(action.params.id)
        newSelection = newSelection.slice(0)
    }
    else {
        newSelection = newSelection.filter(item => item !== action.params.id)
    }

    return ({
        ...reduxState,
        selectedIds: newSelection
    })
}

actionMap[types.SELECT_DOCUMENT] = handler_SELECT_DOCUMENT


// WEBPACK FOOTER //
// ./src/screens/briefing/products/actions/selectDocument.js